import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";
import { CursusStageStatus } from "./Course.d";

export const STAGE_STATUS_CONFIG: Record<CursusStageStatus, { bg: string; icon: string; labelKey: string }> = {
  active: { bg: "success", icon: "dst-icon-check", labelKey: "GLOBAL.ACTIVE" },
  inactive: { bg: "secondary", icon: "dst-icon-alert-octagon", labelKey: "PAGES.COURSE.STATUS.INACTIVE" },
  upcoming: { bg: "warning", icon: "dst-icon-clock", labelKey: "PAGES.COURSE.STATUS.UPCOMING" },
};

export const fetchCursusStages = (
  cursusId: string,
  setCursusStages: Function,
  setLoading: Function,
  language: string,
  setFetchError: Function,
  onSuccess?: Function
) => {
  if (!cursusId) return;
  setLoading(true);

  ApiService.get(`cursus/${cursusId}/stages?fetch_stages_flags=true`)
    .then((response) => {
      setCursusStages(response.data.cursus_stages);
      setFetchError(false);
      onSuccess?.();
    })
    .catch((error) => {
      setFetchError(true);
      console.error("Error fetching cursus stages:", error);
      alert(translate(language, "PAGES.COURSE.ERRORS.FETCH_STAGES"));
    })
    .finally(() => setLoading(false));
};

export const duplicateCursusStage = (stageId: number, language: string, setLoading: Function, onSuccess: Function) => {
  setLoading(true);

  ApiService.post(`cursus/stages/${stageId}/duplicate`, {})
    .then((response) => onSuccess(response.data.cursus_stage.id))
    .catch((error) => {
      console.error("Error duplicating cursus stage:", error);
      alert(translate(language, "PAGES.COURSE.ERRORS.DUPLICATE_STAGE"));
    })
    .finally(() => setLoading(false));
};

export const fetchFlags = (language: string, setFlags: Function, setIsFlagsLoading: Function) => {
  setIsFlagsLoading(true);
  ApiService.get("flags")
    .then((resp) => setFlags(resp.data.flags))
    .catch((error) => {
      console.error("Error fetching flags", error);
      alert(translate(language, "PAGES.COURSE.ERRORS.FETCH_FLAGS"));
    })
    .finally(() => setIsFlagsLoading(false));
};
